import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';
import { AgentDetails } from '../../shared/models/agent-resources/agent-resource';
import { Address } from '../../shared/models/deal-resources/address.model';
import { DealStatuses } from '../../shared/models/deal-resources/enumerators';
import { DashboardBorrower } from './dashboard-borrower.model';
import { DashboardDealDocument } from './dashboard-deal-document.model';

@HateoasResource('dashboardDeals')
export class DashboardDeal extends Resource {
  portalUrl: string;
  purpose: string;
  dealKey: string;
  loanCode: string;
  status: DealStatuses;
  closingDate: Date;
  agent: AgentDetails;
  subjectPropertyAddress: Address;
  borrowers: DashboardBorrower[];
  documents: DashboardDealDocument[];

  // Client-side calculated fields
  progressPercentage: number;
  portalProgressPercentage: number;
  panelState: DealPanelStates;
  progressState: DealProgressStates;

  resolvePanelState(): DealPanelStates {
    let dealPanelState: DealPanelStates = DealPanelStates.Completed;

    if (this.status == DealStatuses.Lead) {
      dealPanelState = DealPanelStates.InProgress;
    }

    let requiresDealDocuments = false;
    if (this.documents) {
      requiresDealDocuments = this.documents.some(d => !d.hasFile);
    }

    // Not lead and document status not 100%
    if (this.status != DealStatuses.Lead && requiresDealDocuments) {
      dealPanelState = DealPanelStates.Submitted;
    }

    // Not lead and document status is 100%
    if (this.status != DealStatuses.Lead && !requiresDealDocuments) {
      dealPanelState = DealPanelStates.Completed;
    }

    this.panelState = dealPanelState;
    return dealPanelState;
  }
}

export enum DealPanelStates {
  // Lead status
  InProgress,

  // Deal status New
  Submitted,

  // One or more borrowers not complete
  WaitingOnBorrower,

  // All borrowers submitted
  // Document progress 100%
  Completed,
}

export enum DealProgressStates {
  InProgress = 1,
  BorrowerReview = 2,
  BorrowerSubmit = 3,
  DocumentsCollection = 4,
  AgentReview = 5,
  Submitted = 6,
  Closing = 7,
  Complete = 8,
}
